export default "__VITE_ASSET__BNWsmi8g__"